import { ReactNode } from 'react';
import './DesignEditSectionContainer.scss';

type DesignEditSectionContainerProps = Readonly<{
  children: ReactNode;
}>;

/**
 * This component was isolated because it uses custom styles outside of
 * the nimbus design system.
 */

export default function DesignEditSectionContainer({
  children,
}: DesignEditSectionContainerProps) {
  return (
    <div className="stratus--design-edit-section">
      <div className="stratus--design-edit-section__container">
        <div className="stratus--design-edit-section__skeleton-top" />

        <div className="stratus--design-edit-section__box-primary">
          {children}
        </div>

        <div className="stratus--design-edit-section__skeleton-bottom" />
      </div>
    </div>
  );
}
